module.exports = __webpack_public_path__ + "img/clothing151.4bfecfc0.jpg";